var modal = {
  modal_el: $('#post-modal'),
  bg_el: $('#post-modal .modal-bg'),
  scroll_el: $('#post-modal .modal-scroll-wrap'),
  cont_el: $('#post-modal .modal-cont'),
  close_btn: $('#post-modal .modal-close-btn'),
  wd_scroll: 0,
  modal_trans_time: 800,

  // init: function() {
  //   modal.close_btn.on('click.close', function(e) {
  //     console.log('close');
  //     e.preventDefault();
  //     modal.close();
  //   });
  // },

  addLoader: function () {
    var s = this;
    var _loader = '<svg viewBox="0 0 50 50" class="center loader-icon modal-loader">\
        <circle class="line anim-loader" cx="25" cy="25" r="22.5" />\
        </svg>';
    var bg_el = s.modal_el.is('.change') ? s.scroll_el : s.bg_el;
    bg_el.append(_loader);
  },

  beforeOpen: function() {
    headerNav.closeAll();
    $('.dropdown-nav').removeClass('open');
    // modal.wd_scroll = $(window).scrollTop();
    // $('body').addClass('modal-show');
    // if (tt_full_scroll) fullScroll.kill();
  },

  openbg: function () {
    var s = this;
    s.beforeOpen();
    // console.log(modal.wd_scroll);
    s.modal_el.css('display', 'block');
    setTimeout(function () {
      s.bg_el.addClass('showin');
      s.addLoader();
    }, 10);

    // if (body_el.is('.home')) pageHome.swiperPause();
  },

  closebg: function () {
    var s = this;
    s.bg_el.html('').removeClass('showin');
  },

  open: function () {
    var s = this;
    s.modal_el.find('.modal-loader').remove();
  
    setTimeout(function () {
      // modal.scroll_el.scrollTop(0);
      s.modal_el.addClass('showin').removeClass('change');
      // modal.showCont();
    }, 100);

    body_el.addClass('modal-show');

    // if (Swal) Swal.close();
  },

  // showCont: function () {
  //   var trans_time = modal.modal_trans_time;
  //   setTimeout(function () {
  //     if ($('html').is('.phone')) modal.touchScroll();
  //   }, trans_time);
  // },

  close: function () {
    var modal_el = modal.modal_el, scroll_el = modal.scroll_el, cont_el = modal.cont_el;

    modal_el.data('scrolltop-' + modal_el.data('postid'), scroll_el.scrollTop());

    // if (Swal) Swal.close();
    if (ttLightBox) ttLightBox.close();
    // if (ttSkrollr) ttSkrollr.init();
    ajaxLoad.modal_is_open = false;
    // if ($('html').is('.mobile')) modal.killTouchEvents();
    
    // if (tt_full_scroll) {
    //   fullScroll.kill();
    //   fullScroll.kill($('main'));
    // }

    modal_el.find('.close-tip').removeClass('showin');
    mdClose();

    function mdClose() {
      // console.log(modal.wd_scroll);
      // setTimeout(function () {
      //   $(window).scrollTop(modal.wd_scroll);
      // }, 20);

      modal_el.addClass('close');
      modal.closebg();
      
      setTimeout(function () {
        closeEnd();
      }, modal.modal_trans_time);
    }
    
    function closeEnd() {
      if (ttSkrollr) ttSkrollr.init();
      body_el.removeClass('modal-show');
      
      // if (ttFluentform && $('#fluentform_replace').length) ttFluentform.modal_reset();

      modal_el.css('display', '').removeClass('close showin touch_close').removeClass(ajaxLoad.modalClass);
      scroll_el.removeClass('close').removeAttr('style');
      cont_el.html('').removeAttr('style');
      modal.close_btn.removeClass('active');
      // if (tt_full_scroll) fullScroll.init();
      if (ajaxLoad != undefined) ajaxLoad.is_closeing = false;

      // if (body_el.is('.home')) pageHome.swiperReplay();
    }
  }


  // Mobile touch enevt
  
  // touchScroll: function () {
  //   var md = modal.modal_el,
  //       scroll_el = modal.scroll_el,
  //       scroll_el_class = '.modal-scroll-wrap',
  //       close = false,
  //       touch_close = false;

  //   // 如果没有滚动容器选择器，或者已经绑定了滚动时间，忽略
  //   if ( md.data('isBindScroll') ) {
  //     return;
  //   }

  //   // 是否是搓浏览器
  //   // 自己在这里添加判断和筛选
  //   // var isSBBrowser = false;

  //   var data = {
  //     posY: 0,
  //     maxscroll: 0
  //   };

    
  //   // 事件处理
  //   md.on({
  //     touchstart: function (event) {
  //       var events = event.originalEvent.touches[0] || event;

  //       // 先求得是不是滚动元素或者滚动元素的子元素
  //       var elTarget = $(event.target);
  //       if (!elTarget.length) {
  //         return;
  //       }

  //       var elScroll;

  //       // 获取标记的滚动元素，自身或子元素皆可
  //       if (elTarget.is(scroll_el_class)) {
  //         elScroll = elTarget;
  //       } else if ((elScroll = elTarget.parents(scroll_el_class)).length == 0) {
  //         elScroll = null;
  //       }

  //       if (!elScroll) {
  //         return;
  //       }

  //       // 当前滚动元素标记
  //       data.elScroll = elScroll;

  //       // 垂直位置标记
  //       data.posY = events.pageY;
  //       data.scrollY = elScroll.scrollTop();
  //       // 是否可以滚动
  //       data.maxscroll = elScroll[0].scrollHeight - elScroll[0].clientHeight;

  //       close = false;
  //       // 如果已到底部，启用上滑关闭
  //       touch_close = data.scrollY + 1 >= data.maxscroll ? true : false;
  //     },

  //     touchmove: function (event) {
  //       // 滚动元素
  //       var elScroll = data.elScroll;
  //       // 当前的滚动高度
  //       var scrollTop = elScroll.scrollTop();

  //       // 现在移动的垂直位置，用来判断是往上移动还是往下
  //       var events = event.originalEvent.touches[0] || event;
  //       // 移动距离
  //       var distanceY = events.pageY - data.posY;
        
  //       // if (isSBBrowser) {
  //       //   elScroll.scrollTop(data.scrollY - distanceY);
  //       //   elScroll.trigger('scroll');
  //       //   return;
  //       // }

  //       var touchClose = function () {
  //         // console.log(distanceY);
  //         var end_sc = 1 - Math.abs(distanceY) / md.height();
  //         scroll_el.css({
  //           // 'overflow': 'hidden',
  //           '-webkit-transition': 'all 0.2s',
  //           'transition': 'all 0.2s',
  //           '-webkit-transform': 'scale(' + end_sc + ')',
  //           'transform': 'scale(' + end_sc + ')'
  //         });

  //         close = end_sc < 0.8 ? true : false;
  //         if (close) modal.close_btn.addClass('active');
  //         else modal.close_btn.removeClass('active');
  //       };

  //       // 如果不足于滚动，则禁止触发整个窗体元素的滚动
  //       // if (data.maxscroll <= 0 || isSBBrowser) {
  //       if (data.maxscroll <= 0) {
  //         touchClose();
  //         event.preventDefault();
  //       }
        
  //       // 上下边缘检测

  //       // 往上滑，并且到头
  //       if (distanceY > 0 && scrollTop == 0) {
  //         event.preventDefault();
  //         return;
  //       }
  //       // 往下滑，并且到头
  //       if (distanceY < 0 && (scrollTop + 1 >= data.maxscroll)) {
  //         if(touch_close) touchClose();
  //         event.preventDefault();
  //         return;
  //       }
  //     },

  //     touchend: function () {
  //       data.maxscroll = 0;
  //       if (close) {
  //         md.addClass('touch_close');
  //         if (ajaxLoad != undefined) ajaxLoad.closeModal();
  //         else modal.close();
  //       } else {
  //         scroll_el.removeAttr('style');
  //       }
  //     }
  //   });

  //   scroll_el.on('scroll.tip', function(){
  //     var tip_el = md.find('.close-tip');
  //     var maxscroll = scroll_el[0].scrollHeight - scroll_el[0].clientHeight;
  //     var top = scroll_el.scrollTop();
  //     if (maxscroll > 0 && top + 1 >= maxscroll) tip_el.addClass('showin');
  //     else tip_el.removeClass('showin');
  //   });

  //   // 防止多次重复绑定
  //   md.data('isBindScroll', true);
  // }

  // killTouchEvents: function () {
  //   var md = modal.modal_el;
  //   var scroll_el = modal.scroll_el;
  //   md.off('touchstart touchmove touchend');
  //   scroll_el.off('scroll.tip');
  // }
}
